export default __webpack_public_path__ + "static/media/Calibre-Semibold.0208f194.ttf";